import React from 'react';

import Data from 'data';
import Locale from 'data/locale';
import EditingContext from 'store/editingContext';
import Store from 'store';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import useApi from 'api';
import SearchResults from './SearchResults';
import useLoadProfile from './useLoadProfile';

const _L = Locale("ui-import");

export default function SearchSection() {
  const [searching, setSearching] = EditingContext.useState("searchSearcing", false);
  const [result, setResult] = EditingContext.useState("searchResults");
  const [searchParams, setSearchParams] = EditingContext.useState("searchParams");

  const store = Store.useStore();
  const [charClass, setCharClass] = React.useState(() => {
    const state = store.getState();
    const profile = state.profiles[state.activeProfile];
    return profile.class;
  });
  const onChangeCharClass = React.useCallback(e => setCharClass(e.target.value), []);

  const api = useApi();

  const runSearch = React.useCallback(params => {
    setSearching(true);
    api.search(params).then(
      result => {
        if (result.length) {
          setResult({results: result, count: result.length});
        } else {
          setResult({error: _L`No results.`});
        }
      },
      error => {
        setResult({error: error.message});
      },
    ).finally(() => setSearching(false));
  }, [api, setSearching, setResult]);

  const onSearch = React.useCallback(() => {
    const params = {cls: charClass, order: "popularity"};
    setSearchParams(params);
    runSearch(params);
  }, [setSearchParams, runSearch, charClass]);

  const onSearchNav = React.useCallback(params => {
    runSearch({...searchParams, ...params});
  }, [searchParams, runSearch]);

  const loadProfile = useLoadProfile();

  return (
    <div className="d2p-SectionContent d2p-section-search">
      <div className="d2p-import-options">
        <select value={charClass} onChange={onChangeCharClass} disabled={searching} className="d2p-search-class">
          <option value="">{_L`Any Class`}</option>
          {Data.classes.map(id => <option key={id} value={id}>{Locale.strings[Data.classNames[id]]}</option>)}
        </select>

        <button onClick={onSearch} disabled={searching}>
          {searching && <FontAwesomeIcon icon={faSpinner} spin/>}
          {searching ? _L`Searching` : _L`Search`}
        </button>
      </div>
      {!!(result && result.results) && <SearchResults results={result} onSearch={onSearchNav} disabled={searching} onClick={loadProfile}/>}
      {!!(result && result.results && !result.count) && <div className="d2p-import-error">{_L`No results.`}</div>}
      {!!(result && result.error) && <div className="d2p-import-error">{result.error}</div>}
    </div>
  );
}
